import { Component } from '@angular/core';
import { MessageService, ConfirmationService, ConfirmEventType } from 'primeng/api';
import { UsuarioSesion } from 'src/app/models/usuario-sesion.interface';
import { HttpPaginacion, Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Distribuidor } from 'src/app/models/distribuidor.interface';
@Component({
  selector: 'app-administrador-distribuidores',
  templateUrl: './administrador-distribuidores.component.html',
  styleUrls: ['./administrador-distribuidores.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class AdministradorDistribuidoresComponent {
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 120;
  distribudorPageInformacion: HttpPaginacion<Distribuidor> | undefined;
  distribuidorPage: Distribuidor[] = [];

  constructor(
    private administradorService: AdministradorService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService) {
    this.obtenerInformacion(1);
  }

  obtenerInformacion(page: number): void {
    this.administradorService.distribuidores(page)
      .subscribe({
        next: (resp) => {
          this.distribudorPageInformacion = resp;
          this.distribuidorPage = resp.data;

          this.first = (resp.current_page - 1) * resp.per_page;
          this.rows = resp.per_page;
          this.totalRecords = resp.total;
        },
        error: (err) => console.log(err)
      })
  }

  onPageChange(event: any) {
    const paginar: Paginar = <Paginar>event;
    const paginaActual = paginar.page + 1;
    this.obtenerInformacion(paginaActual);
    //console.log(this.first/ this.rows, event);
  }
  mensaje(usuario: UsuarioSesion): void {

    alert(usuario.nom_completo)
  }
  confirmacion(usuario: UsuarioSesion) {
    this.confirmationService.confirm({
      message: `Estas seguro que quieres desactivas a ${usuario.nom_completo}`,
      header: 'Confirmacion',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {

        this.administradorService
          .desactivarUsuario(usuario.id)
          .subscribe({
            next: (resp) => {
              usuario.activo = 0;
              this.messageService.add({ severity: 'info', summary: 'Confirmacion', detail: resp.mensaje });
            },
            error: (err: HttpErrorResponse) => { this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: err.error.message }); }
          })

        // 
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            this.messageService.add({ severity: 'error', summary: 'Rechazada', detail: 'Confirmacion rechazada' });
            break;
          case ConfirmEventType.CANCEL:
            this.messageService.add({ severity: 'warn', summary: 'Cancelada', detail: 'Opcion Cancelada' });
            break;
        }
      }
    });
  }
}
